import React from "react"
import Img from "gatsby-image"
import { StaticQuery, graphql } from "gatsby"

import styled from "styled-components"

const Styledlogo = styled.div`
  > .gatsby-image-wrapper {
    img {
      padding-bottom: 32px;
    }
  }
`

export const Eventlogo = () => (
  <StaticQuery
    query={graphql`
      query {
        eventlogo: file(relativePath: { eq: "imdex-logo.png" }) {
          childImageSharp {
            fluid(maxWidth: 120) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => (
      <Styledlogo>
        <Img fluid={data.eventlogo.childImageSharp.fluid} className="logo" />
      </Styledlogo>
    )}
  />
)
